import React from 'react';
import {observer} from "mobx-react";
import {selectedCompanyStore} from "../store/SelectedCompany";
import Loader from "./Loader";
import {CompaniesStoreStates, userInfoStore} from "../store/UserInfo";
import {Grid, Typography} from "@mui/material";
import {Trans} from "react-i18next";

interface IProps {
    loading: boolean,
    error?: boolean | string,
}

interface IState {
}

@observer
export default class LoaderWithCompanySelected extends React.Component<IProps, IState> {

    render() {
        if (!selectedCompanyStore.isSelected) {
            if (userInfoStore.companiesLoadingState === CompaniesStoreStates.DONE) {
                if (userInfoStore.companies.length === 0) {
                    return (
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Typography variant="h5">
                                        <Trans i18nKey="loader_screen.no_company_assigned">
                                            You don't have a company assigned to your account
                                        </Trans>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="h6">
                                        <Trans i18nKey="loader_screen.no_company_action">
                                            If you have any questions related to our services please use the chat button in the right corner and we will contact you as soon as
                                            possible.
                                        </Trans>
                                    </Typography>
                                </Grid>
                            </Grid>
                    );
                } else {
                    return (
                            <div>
                                <Typography variant="h3"><Trans i18nKey="loader_screen.select_company">Please select company first</Trans></Typography>
                            </div>
                    );
                }
            } else {
                return <Loader loading={true}/>
            }
        } else {
            return <Loader {...this.props}/>
        }
    }


}